// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Clock } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconClock(props: any) {
    return <IconBase icon={Clock} {...props} />
  }

  export default IconClock
  